import React from 'react';
import styles from '../RequestsLineChart.module.scss';

const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    const { payload: data } = payload[0];

    return (
      <div className={styles.tooltip}>
        <span>{`${data.name}, ${data.day}`}</span>
        <span style={{ fontWeight: 700 }}>Кол-во заявок: {data.value}</span>
      </div>
    );
  }

  return null;
};

export default CustomTooltip;
